import { filter } from 'rxjs/operators';

import ErrorType from '../Constants/Error.type';

const fatalErrors = [
    ErrorType.API_SERVICE_PLAYBACK,
    ErrorType.API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT,
    ErrorType.API_SERVICE_PLAYBACK_RESTRICTED_LOCATION,
    ErrorType.PLAYBACK_SOURCE_STARTUP,
    ErrorType.PLAYBACK_SOURCE_MIDSTREAM,
    ErrorType.LICENSE_REQUEST_FAILED,
    ErrorType.CERTIFICATE_REQUEST_FAILED,
    ErrorType.PLAYBACK_INTERRUPTED_CONNECTION_LOST,
];

const createFatalErrorStream = reportError$ =>
    reportError$
        .pipe(
            filter(error => fatalErrors.includes(error.type))
        );

export {
    fatalErrors,
    createFatalErrorStream as default,
};
